import { Injectable } from '@angular/core';
import type { AlertType, GsmFrontendAlert } from '@models/gsm.model';
import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FoerchAlertService {
  private _alertsStore: GsmFrontendAlert[] = [];
  private _alerts$ = new BehaviorSubject<GsmFrontendAlert[]>([]);

  getAlerts(): Observable<GsmFrontendAlert[]> {
    return this._alerts$.asObservable();
  }

  /**
   * Shows an alert
   *
   * @param type Type of alert, important for CSS coloring
   * @param message Text that is rendered to template
   * @param hideInMilliseconds Milliseconds until the alert fades away
   */
  showAlert(
    type: AlertType,
    message: string,
    hideInMilliseconds: number
  ): void {
    const id = new Date().getTime();

    this._alertsStore.push({
      id,
      alert: {
        type,
        message,
      },
    });

    this._alerts$.next(this._alertsStore);

    setTimeout(() => {
      this._alertsStore = this._alertsStore.filter(e => e.id !== id);
      this._alerts$.next(this._alertsStore);
    }, hideInMilliseconds);
  }
}
